module.exports = __webpack_public_path__ + "static/Handel_im_Wandel-3b6d4de1ec89413c2718ec4c5a193556.png";